import { render, staticRenderFns } from "./DashboardGalerie.vue?vue&type=template&id=223b5593&"
import script from "./DashboardGalerie.vue?vue&type=script&lang=js&"
export * from "./DashboardGalerie.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGalerie.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports